import { Expose } from "class-transformer";

export class UpdateProjectHasCurrencyDto {
  @Expose()
  id: string;
}
